<template>
  <div id="resources">
    <div class="resources-content">
      <div class="resources-banner">
        <img src="../../../static/images/resources-banner.jpg" alt="">
      </div>

      <div class="resources-main">

        <div class="resources-detail">
          
          
          <div class="resources-icon">
            <img src="../../../static/images/resources-icon1.png" alt="">
          </div>

          <div class="resources-kh" v-html="resources_kh"></div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Resources',
  data() {
    return {
      resources_kh:"你拥有自己的互联网入口资源,我们提供<br/>专属链接或者专属办理界面，你只需做一个简单的嵌入即可坐等收入。"
    }
  },
  created () {
    /*this.getConpy();*/
  },
  methods: {
    
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .resources-banner
    img
      width 100%

  .resources-main
    width 1080px
    margin 0 auto

    .resources-detail
      margin 0 auto

      .resources-icon
        margin-top 50px
        img
         width 100%

      .resources-kh
        margin 75px 0
        padding 20px
        font-size 30px
        color #000000
        text-align center
        line-height 60px

    
</style>



// WEBPACK FOOTER //
// src/components/service/resources.vue